import lottie from "lottie-web";

function initMediasEvents() {
    window.addEventListener('toggleMedia', (e) => {
        const { target, way, from } = e.detail;

        if (way == 'enter') {
            playMedia(target);
        }
        
        if (way == 'leave') {
            pauseMedia(target);
        }
    });
}

function getMediaType(elt) {
    if (elt.classList.contains('-image')) return "image";
    if (elt.classList.contains('-video')) return "video";
    if (elt.classList.contains('-lottie')) return "lottie";
    return null;
}

function getLottieById(id) {
    let lotties = lottie.getRegisteredAnimations();
    let anim = null;
    
    if (lotties) {
        lotties.forEach((l) => {
            if (l.animationID == id) {
                anim = l;
            }
        })
    }

    return anim;
}

function playMedia(elt) {
    let type = getMediaType(elt);

    if (type == "video") {
        if (elt.querySelector('video')) {
            elt.querySelector('video').play();
        }
    }
    if (type == "lottie") {
        let lottieId = elt.querySelector('.c-media_lottie').getAttribute('data-lottie-id');
        let lottieAnim = getLottieById(lottieId);
        if (lottieAnim) {
            lottieAnim.play();
        }
    }
}

function pauseMedia(elt) {
    let type = getMediaType(elt);

    if (type == "video") {
        if (elt.querySelector('video')) {
            elt.querySelector('video').pause();
        }
    }
    if (type == "lottie") {
        let lottieId = elt.querySelector('.c-media_lottie').getAttribute('data-lottie-id');
        let lottieAnim = getLottieById(lottieId);
        if (lottieAnim) {
            lottieAnim.pause();
        }
    }
}


export { initMediasEvents, getMediaType, getLottieById };
